import type { ActivityLogsRequest } from '@/models/interface/social';
import { api } from '@/services';
import { getUnixTime } from 'date-fns';

interface ActivityLogsBaseBody {
  /** 事件類型 ID */
  eventTypeId: string;
  /** 課程 or 文章 ID */
  resourceId?: string;
  /**
   * 事件描述內容
   *
   * @remarks `{使用者 nickname + 事件描述 description}`
   */
  details: string;
}

/**
 * 活動日誌 API Composable
 */
export function useActivityLogsApi() {
  const userStore = useUserStore();

  /**
   * 建立 事件活動日誌
   * @param body - 活動日誌請求酬載
   *
   * 事件對應表 @see {@link https://drive.funday.asia/oo/r/18ZQBwjsvqMHmBSwXgIRqHNFXqsweugq#tid=4}
   */
  const createActivityLogsEvt = async (body: ActivityLogsBaseBody): Promise<void> => {
    try {
      const payload: ActivityLogsRequest = {
        ...body,
        timestamp: getUnixTime(new Date()),
        applicationId: '66e2b8e98254f24941876231',
        userId: userStore.userData?.memberId ?? 0,
        resourceId: body.resourceId ?? ''
      };

      await api.socialLog.setActivityLogs(payload);
    } catch (errors: unknown) {
      console.error(
        '[Create Activity Logs Exceptions] Failed to create activity logs event',
        errors
      );
    }
  };

  return {
    createActivityLogsEvt
  };
}
